// Purpose: Product sync API calls (Shopee/TikTok)
// Caller: SyncProductModal
// Dependencies: utils/xhr
// Main Functions: syncProduct
// Side Effects: HTTP POST /{platform}/sync-product

import { xhr } from 'utils'

export const syncProduct = (platform, data) =>
  xhr.post(`/${platform}/sync-product`, data)
